import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'new-landing';
  isPatientPortalRoute = false;
  isFormRoute = false;

  constructor(private router: Router){
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if(event.url.match('patient-portal') || event.url.match('patient-login') ){
          this.isPatientPortalRoute = true;
        }

        if(event.url.includes('form')){
          this.isPatientPortalRoute = true;
        }
      }
    });
  }
}
